{
    "Para1": "Wählen Sie aus den folgenden Optionen ein Dashboard-Layout aus:",
    "DashboardDisplaySettings_SectionHeader": "Bildschirmeinstellungen",
    "NAME": "DashboardDisplaySettings"
}